import { IAppState } from '../../redux';
import { EOfferStatus } from '../../redux/reducers';

export function selectIsDraftOffer(state: IAppState): boolean {
  return state.offer.status === EOfferStatus.draft;
}
